import { matchPath } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import useViewport from 'src/hooks/useViewport'
import classnames from 'classnames'
import { getCurrentPath } from 'src/helpers/browser'
import { PATH_HELPERS } from 'src/constants/navigation'
// Components
import FooterText from 'src/Components/homeSearch/Footer/FooterText/FooterText'
import Disclaimer from 'src/Components/shared/Disclaimer'
import HousingType from 'src/Components/buyers/HousingType'
import { Text } from 'src/Components'
import DataSourceDisclaimer from './DataSourceDisclaimer/DataSourceDisclaimer'
// Styles
import styles from './Footer.module.scss'

const HomeSearchFooter = () => {
  const { isMediumOrAbove } = useViewport()

  const isListing = !!matchPath(getCurrentPath(), {
    path: PATH_HELPERS.listing.matchPath,
  })

  const isListings = !!matchPath(getCurrentPath(), {
    path: PATH_HELPERS.listings.matchPath,
  })

  const isListingsOrListingDetails = isListings || isListing

  return (
    <footer
      className={classnames(
        styles.root,
        !isListing && !isListings && styles.centered,
        isMediumOrAbove && isListing && styles.twoColumn
      )}
    >
      <div
        className={classnames(isListingsOrListingDetails && styles.disclaimers)}
      >
        {isListingsOrListingDetails && (
          <Text
            element='h2'
            size='l'
            variant='neutralCool'
            variantCount='900'
            weight='bold'
            align='left'
            className={styles.heading}
          >
            <FormattedMessage
              id='HomeSearch.footer.disclaimers'
              defaultMessage='Disclaimers'
            />
          </Text>
        )}

        <Disclaimer
          className={classnames(
            isListingsOrListingDetails && styles.disclaimer
          )}
          staticContext={undefined}
        />

        {isListing && (
          <div
            className={classnames(
              isListingsOrListingDetails && styles.disclaimer
            )}
          >
            <DataSourceDisclaimer />
          </div>
        )}
      </div>
      <div className={styles.lender}>
        <HousingType className={styles.housingType} />
        <FooterText className={styles.footerText} />
      </div>
    </footer>
  )
}

export default HomeSearchFooter
